<script setup>
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { exportAnswerRecord } from '@/api/admin'
import { WebBridgeApi } from 'ijsbridge'
import qs from 'qs'
import { isInApp } from '@/utils/tools'

const props = defineProps({
  formTree: {
    type: Object,
    default: () => {},
  },
  recordType: Number,
  formDate: Object,
})

const route = useRoute()
// questionActiveKey: route.query.questionActiveKey,
//     // pageNum: 1,
//     // pageSize: 10,
//     recordType: props.recordType,
//     ...props.formTree,
//     ...props.formDate,
const loading = ref(false)
const handleExportClick = async () => {
  if (loading.value) {
    return
  }
  // https://app-survey.litenews.cn/api
  // http://10.0.117.248:8081/
  const url = `https://app-survey.litenews.cn/api/question_active/school_export?questionActiveKey=${
    route.query.questionActiveKey
  }&recordType=${props.recordType}&${qs.stringify(
    props.formTree
  )}&${qs.stringify(props.formDate)}`

  if (isInApp()) {
    WebBridgeApi.requestApi('openLink', {
      url,
    })
  } else {
    window.open(url)
  }
}

const exportData = (res) => {
  const blob = new Blob([res]) // 接受文档流
  if (isInApp()) {
    console.log('---', window.URL.createObjectURL(blob))
    WebBridgeApi.requestApi('openLink', {
      url: `http://10.0.117.186:8081/question_active/school_export?questionActiveKey=${route.query.questionActiveKey}&recordType=${props.recordType}`,
    })
    return
  }

  if ('msSaveOrOpenBlob' in navigator) {
    // IE下的导出
    window.navigator.msSaveOrOpenBlob(blob, '导出文件' + '.xlsx') // 设置导出的文件名
  } else {
    // 非ie下的导出
    const a = document.createElement('a')
    const url = window.URL.createObjectURL(blob)
    const filename = '导出文件' + '.xlsx' // 设置导出的文件名
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
  }
}
</script>
<template>
  <img
    @click="handleExportClick"
    class="export-btn"
    src="@/assets/img/admin/export-btn.png"
    alt=""
  />
</template>

<style lang="scss" scoped>
.export-btn {
  position: fixed;
  bottom: 20%;
  right: 20px;
  width: 112px;
  height: 112px;
  border-radius: 50%;
  z-index: 2077;
}
</style>
